function MapData(data) {

  let elements = data.elements;

  elements.map(element => {
    element.displayPos = {
      x: element.pos.x,
      y: element.pos.y
    };
    return element;
  });

  this.hasGender = (i) => {
    let gender = this.getGender(i);
    return typeof(gender) === 'string' && gender !== 'unknown';
  };

  this.hasFlag = (i) => {
    let countryCode = this.getCountryCode(i).toLowerCase();
    return typeof(countryCode) === 'string' && countryCode.length > 0;
  };

  this.hasStartYear = (i) => {
    let startYear = elements[i].start_year;
    return typeof(startYear) === 'string' && startYear.length > 0;
  };

  this.getElementsNumber = () => {
    return elements.length;
  };

  this.getName = (i) => {
    return elements[i].name;
  };

  this.getElementsNames = () => {
    return elements.map(element => element.name);
  };

  this.setElementDisplayX = (i, value) => {
    elements[i].displayPos.x = value; 
  };

  this.setElementDisplayY = (i, value) => {
    elements[i].displayPos.y = value; 
  };

  this.getElementDisplayX = (i) => {
    return elements[i].displayPos.x;
  };

  this.getElementDisplayY = (i) => {
    return elements[i].displayPos.y;
  };

  this.getElementX = (i) => {
    return elements[i].pos.x;
  };

  this.getElementY = (i) => {
    return elements[i].pos.y;
  };

  this.getElementColor = (i) => {
    let value = elements[i].color;
    let color;

    if (value === 3)
      color = '#FAD482'; 
    else if (value === 2)
      color = '#FAAC05'; 
    else if (value === 1)
      color = '#FA6F05';    
    else    
      color = '#F10635'; 

    return color;
  };

  this.getElementSize = (i) => {
    let value = elements[i].size;
    let size;
    if (value === 4)
      size = '0.55em';
    else if (value === 3)
      size = '0.65em';
    else if (value === 2)
      size =  '0.75em';
    else if (value === 1)
      size = '0.85em';    
    else 
      size = '1.em';

    return size;  
  };

  this.getCountryCode = (i) => {
    return elements[i].country_code.toLowerCase();
  };

  this.getGender = (i) => {
    return elements[i].gender;
  };

  this.getStartYear = (i) => {
    return elements[i].start_year;
  };

  this.getPicture = (i) => {
    return elements[i].img;
  };

  this.getTags = (i) => {
    return elements[i].tags;
  };

  this.getElement = (i) => {
    return elements[i];
  };

  this.getArtists = () => {
    if (elements.length === 0)
      return [];
    else
      return this.getElementsNames().map((artist) => { return {artist} } );
  };

  this.getElementEdges = (i) => {
    return elements[i].connections.map(connection => connection.index);
  };

  this.getConnectedNames = (i) => {
    let directConnections = elements[i].connections.map(connection => connection.name);
    let indirectConnections = elements[i].indirectConnections.map(connection => connection.name);
    return directConnections.concat(indirectConnections);
  };

  elements.forEach(element => {
    element.indirectConnections = [];
  });

  elements.forEach((element, index) => {
    element.connections.forEach(connection => {
      elements[connection.index].indirectConnections.push({name: element.name, index: index}); 
    });
  });

}

module.exports = MapData


// WEBPACK FOOTER //
// ./src/js/models/MapData.js